module.exports = __webpack_public_path__ + "00_glasses.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/00_glasses.png
// module id = LGAb
// module chunks = 0